<template>
    <div class="container">
        <div v-if="loadingStuffMembers && teamMembers && teamMembers.length" class="row py-4">
            <div v-for="(index) in teamMembers.length" :key="index" class="col-lg-3 col-md-4 col-sm-6 col-6 mb-4">
                <img src="/wp-content/themes/understrap-child/conferences-app-vue/walkuere_conferences_vue_app/src/assets/partners/Single card of team-expert with placeholder.svg" alt="loadingStuffMembers">
            </div>
        </div>
        <div v-if="!loadingStuffMembers && teamMembers && teamMembers.length" class="team-tab">
            <h2 class="h4 font-weight-bold py-4">{{ $t('Partners.contactOurPartner') }}</h2>
            <div class="row">
                <div  v-for="member in teamMembers.slice().sort((a, b) => a.lastName.localeCompare(b.lastName))"  :key="member.email" class="col-lg-3 col-md-4 col-sm-6 col-6 mb-4">
                    <!-- <a v-if="member.contactEmail"  :href="`mailto:${member.contactEmail}?subject=${encodeURIComponent($t('Partners.emailSubject'))}`"  class="text-decoration-none text-body"> -->
                        <div @click="showPopup = true" class="card mb-4 shadow border-0 h-100 rounded-corners-10 cursor-pointer">
                            <div class="card-body d-flex flex-column align-items-center justify-content-between text-center">
                                
                                <!-- Image Section -->
                                <img v-if="member.avatar.xxx" :src="member.avatar.xxx" alt="Expert" class="img-fluid rounded-circle mb-3 partners-profile-pic" />
                                <img v-if="!member.avatar.xxx" src="/wp-content/themes/understrap-child/conferences-app-vue/walkuere_conferences_vue_app/src/assets/partners/Placeholder PERSON image on png1.svg" alt="Expert" class="img-fluid rounded-circle mb-3 partners-profile-pic"/>

                                <!-- Text Section -->
                                <h6 v-if="member.firstName && member.lastName" class="card-title mb-0 experts-partner-name text-break">{{ member.firstName }} {{ member.lastName }}</h6>
                                <span v-if="member.position" class="card-text subscription-status experts-partner-title text-muted">{{ member.position }}</span>

                                <!-- Email icon -->
                                <div class="mt-2">
                                    <img src="/wp-content/themes/understrap-child/conferences-app-vue/walkuere_conferences_vue_app/src/assets/partners/email.svg" alt="Email Icon" class="email-icon" @click.stop="showPopup = true" />
                                </div>

                            </div>
                        </div>
                    <!-- </a> -->
                </div>
            </div>
        </div>
    </div>

    <!-- Popup -->
    <div v-if="showPopup" class="custom-modal-backdrop">
        <div class="custom-modal-content text-center p-4">
            <!-- Close button -->
            <button @click="showPopup = false" class="close-btn" aria-label="Close">&times;</button>

            <!-- Popup text -->
            <p>{{ $t('Partners.contactPartner') }}</p>

            <!-- Login buttons -->
            <a :href="deepLink" class="btn btn-primary mt-2">{{ $t('Partners.login') }}</a>
        </div>
    </div>

</template>

<script>
    export default {
        name: 'TeamTab',
        props: {
            settingsPerm: Object,
            teamMembers: Array,
            deepLink: String,
            loadingStuffMembers: Boolean
        },
        data() {
            return {
                isDevMioActive: this.settingsPerm.isDevMioActive,
                showPopup: false,
            };              
        },
        created() {
        },
        methods: {
            selectTab(tab) {
                this.selectedTab = tab;
            },
        }

    };
</script>

<style>
        /* mobile device*/
    @media (max-width: 767px) {
        .partners-profile-pic {
            max-width: 100px;
            max-height: 100px;
            width: 100px;
            height: 100px;
        }
    }
</style>